module.exports = __webpack_public_path__ + "static/img/device_bg.a8fd35c0.png";